/** @jsx jsx */
import { useEffect } from 'react';
import { useSkipLinks } from '../../controllers';
export var useCustomSkipLink = function useCustomSkipLink(id, skipLinkTitle) {
  var listIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var _useSkipLinks = useSkipLinks(),
      registerSkipLink = _useSkipLinks.registerSkipLink,
      unregisterSkipLink = _useSkipLinks.unregisterSkipLink;

  useEffect(function () {
    registerSkipLink({
      id: id,
      skipLinkTitle: skipLinkTitle,
      listIndex: listIndex
    });
    return function () {
      unregisterSkipLink(id);
    };
  }, [id, listIndex, skipLinkTitle, registerSkipLink, unregisterSkipLink]);
};